import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import { Color, Width, Spinner } from '@figure/frontlib-gui';
import WarningImage from 'shared/assets/images/warning.svg';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  height: 4.5rem; // To match when spinner is displayed

  @media print, screen and (min-width: ${Width.MD}px) {
    font-size: 1.3rem;
  }
`;

const Name = styled.div`
  flex-grow: 1;
  text-transform: uppercase;

  img {
    width: 22px;
    height: 22px;
    padding-right: 5px;
    vertical-align: bottom;
  }
`;

const Progress = styled.div`
  display: flex;
  align-items: center;
  text-transform: none;

  span:first-child {
    margin-right: 10px;
  }
`;

const DeleteLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: ${Color.MEDIUM_GREY};
  padding-left: 10px;
`;

const AccountHeader = ({ item, handleDelete }) => {
  const renderStatus = (item) => {
    if (item.assetsComplete && typeof item.login === 'object') {
      return <div>Connected</div>;
    } else if (!item.assetsFailed) {
      return (
        <Progress>
          <Spinner />
          Retrieving info...
        </Progress>
      );
    }

    return null;
  };

  const renderDelete = (item) => {
    if (!item.inProgress && item.assetsFailed) {
      return <DeleteLink onClick={() => handleDelete(item)}>Delete</DeleteLink>;
    }

    return null;
  };

  return (
    <Container data-test-id="account-header">
      <Name>
        {item.assetsFailed && <img src={WarningImage} alt="warning" />}
        {item.institution}
      </Name>
      {renderStatus(item)}
      {renderDelete(item)}
    </Container>
  );
};

AccountHeader.propTypes = {
  item: reduxPropTypes.plaidItem.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default AccountHeader;
